"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TipoVal;
(function (TipoVal) {
    TipoVal["ENTERO"] = "ENTERO";
    TipoVal["ID"] = "ID";
    TipoVal["DECIMAL"] = "DECIMAL";
    TipoVal["CADENA"] = "CADENA";
    TipoVal["ARROBA"] = "ARROBA";
    TipoVal["PUNTO"] = "PUTNO";
    TipoVal["LANG"] = "LANG";
    TipoVal["TEXTO"] = "TEXTO";
    TipoVal["POSICION"] = "POSICION";
    TipoVal["NODO"] = "NODO";
    TipoVal["BOLEANO"] = "BOLEANO";
    TipoVal["LAST"] = "LAST";
})(TipoVal = exports.TipoVal || (exports.TipoVal = {}));
